import { SettingConst } from '../../types';

/**
 * Controls full prefetching of logged in home page
 */
export const LOGGED_IN_HOME_PAGE_ROUTE_CHANGE_PREFETCHING_240920 =
  'LOGGED_IN_HOME_PAGE_ROUTE_CHANGE_PREFETCHING_240920' as SettingConst<
    'LOGGED_IN_HOME_PAGE_ROUTE_CHANGE_PREFETCHING_240920',
    boolean,
    'RETAILER'
  >;
